import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false

new Vue({
  router,
  axios,
  render: function (h) { return h(App) }
}).$mount('#app')